const handleLogUserAction = ({ action, mutate, ownProps }) =>
  mutate({
    variables: { action },
    optimisticResponse: {
      __typename: 'Mutation',
    },
  })

export default handleLogUserAction
